'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFacebookProfile = exports.getFacebookToken = exports.messages = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.verifyAndSetToken = verifyAndSetToken;
exports.requestLoginWithAuthToken = requestLoginWithAuthToken;
exports.requestLoginWithCredentials = requestLoginWithCredentials;
exports.requestLoginWithFacebookToken = requestLoginWithFacebookToken;
exports.doHandlePostAuth = doHandlePostAuth;
exports.authorizeFacebook = authorizeFacebook;
exports.doLoginWithAuthToken = doLoginWithAuthToken;
exports.doLoginWithFacebook = doLoginWithFacebook;
exports.doLoginWithCredentials = doLoginWithCredentials;
exports.createUserAndLogIn = createUserAndLogIn;

var _sagaTools = require('@classpass/saga-tools');

var _reactIntl = require('react-intl');

var _reduxForm = require('redux-form');

var _effects = require('redux-saga/effects');

var _MixPanel = require('components/MixPanel/MixPanel');

var _universalLogger = require('universal-logger');

var logger = _interopRequireWildcard(_universalLogger);

var _bound = require('redux/saga/entities/bound');

var _memberStatus = require('enums/memberStatus');

var _GoogleAnalytics = require('components/GoogleAnalytics/GoogleAnalytics');

var _apiErrorCodes = require('constants/api-error-codes');

var _multitrack = require('helpers/multitrack');

var _user = require('redux/modules/user');

var _statsd = require('helpers/statsd');

var _universalConfig = require('universal-config');

var _universalConfig2 = _interopRequireDefault(_universalConfig);

var _universalFetch = require('universal-fetch');

var _universalFetch2 = _interopRequireDefault(_universalFetch);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(requestLoginWithAuthToken),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(requestLoginWithCredentials),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(requestLoginWithFacebookToken),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(doHandlePostAuth),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(authorizeFacebook),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(doLoginWithAuthToken),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(doLoginWithFacebook),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(doLoginWithCredentials),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(createUserAndLogIn);

var FB_NOT_AVAILABLE = 'FB_NOT_AVAILABLE';
var GET_FACEBOOK_TOKEN_FAILED = 'GET_FACEBOOK_TOKEN_FAILED';
var GET_FACEBOOK_PROFILE_FAILED = 'GET_FACEBOOK_PROFILE_FAILED';

var messages = exports.messages = (0, _reactIntl.defineMessages)({
  authError: {
    id: 'login.authentication.failed',
    defaultMessage: 'The password or email address you entered is incorrect. <a href="{resetLink}">Reset your password</a> or <a href="{contactLink}">contact us</a> if youʼre having trouble logging in.',
    values: {
      resetLink: '/reset-password',
      contactLink: '/contact'
    }
  },
  authSecurityError: {
    id: 'location.authentication.security-reset',
    defaultMessage: 'You are required to change your password for security reasons. Please <a href="{resetLink}">reset your password</a> now.',
    values: {
      resetLink: '/reset-password'
    }
  }
});

function verifyAndSetToken(client, token) {
  return (client.fetch || _universalFetch2.default)('/_verifyAuthToken', {
    credentials: 'same-origin',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    body: (0, _stringify2.default)({ token: token })
  }).then(function (res) {
    return res.json();
  }).then(function (data) {
    if (!data.success) {
      var err = new Error(data.message);
      err.code = _apiErrorCodes.ERROR_INVALID_CREDENTIALS;
      throw err;
    }
    return data;
  });
}

function requestLoginWithAuthToken(client, token) {
  var result;
  return _regenerator2.default.wrap(function requestLoginWithAuthToken$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          result = { token: token };
          _context.next = 3;
          return (0, _effects.call)(verifyAndSetToken, client, token);

        case 3:
          return _context.abrupt('return', result);

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function requestLoginWithCredentials(client, email, password) {
  var result;
  return _regenerator2.default.wrap(function requestLoginWithCredentials$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.call)(client.users.loginWithCredentials, { username: email, password: password, client_id: (0, _universalConfig2.default)().clientId });

        case 2:
          result = _context2.sent;
          _context2.next = 5;
          return (0, _effects.call)(verifyAndSetToken, client, result.token);

        case 5:
          return _context2.abrupt('return', result);

        case 6:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function requestLoginWithFacebookToken(client, token) {
  var result;
  return _regenerator2.default.wrap(function requestLoginWithFacebookToken$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.call)(client.users.loginWithFacebook, { token: token, client_id: (0, _universalConfig2.default)().clientId });

        case 2:
          result = _context3.sent;
          _context3.next = 5;
          return (0, _effects.call)(verifyAndSetToken, client, result.token);

        case 5:
          return _context3.abrupt('return', result);

        case 6:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function doHandlePostAuth(client, token, forceReadFromMaster) {
  var user, userType;
  return _regenerator2.default.wrap(function doHandlePostAuth$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.call)([client, client.useToken], token);

        case 2:
          _context4.next = 4;
          return (0, _effects.put)((0, _user.setToken)(token));

        case 4:
          _context4.next = 6;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.userProfile, [client, forceReadFromMaster ? { forceReadFromMaster: true } : {}]);

        case 6:
          user = _context4.sent;
          userType = 'registered';

          if ((0, _memberStatus.memberStatus)('CANCELLED', user.membership.status)) {
            userType = 'churned';
          } else if ((0, _memberStatus.memberStatus)('ACTIVE', user.membership.status)) {
            userType = 'subscribed';
          }

          _context4.next = 11;
          return (0, _effects.all)([(0, _effects.call)(_MixPanel.mixpanel.register, { user_id: user.id }), (0, _effects.call)(_MixPanel.mixpanel.identify, user.id), (0, _effects.call)(_multitrack.setUserId, user.id), (0, _effects.call)(_multitrack.ga, 'set', _GoogleAnalytics.dimensions.USER_ID, String(user.id)), (0, _effects.call)(_multitrack.ga, 'User', 'Log In', user.id), (0, _effects.call)(_multitrack.ec, 'Log In', { user_type: userType })]);

        case 11:

          if (window.Rollbar) {
            window.Rollbar.configure({
              payload: {
                person: {
                  id: user.id
                }
              }
            });
          }

        case 12:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

var getFacebookToken = exports.getFacebookToken = function getFacebookToken(FacebookSDK) {
  return new _promise2.default(function (resolve, reject) {
    return FacebookSDK.login(function (response) {
      return response && response.authResponse && response.authResponse.accessToken ? resolve(response.authResponse.accessToken) : reject(new Error(GET_FACEBOOK_TOKEN_FAILED));
    }, { scope: 'email,public_profile,user_friends' });
  });
};

var getFacebookProfile = exports.getFacebookProfile = function getFacebookProfile(FacebookSDK) {
  return new _promise2.default(function (resolve, reject) {
    return FacebookSDK.api('/me?fields=email,first_name,gender,last_name,link,locale,name,timezone,updated_time,verified', function (response) {
      return !response || response.error ? reject(new Error(GET_FACEBOOK_PROFILE_FAILED)) : resolve(response);
    });
  });
};

function authorizeFacebook(client) {
  var FB, facebookToken, message;
  return _regenerator2.default.wrap(function authorizeFacebook$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          FB = client && client.FB || window.FB;
          _context5.prev = 1;

          if (FB) {
            _context5.next = 4;
            break;
          }

          throw new Error(FB_NOT_AVAILABLE);

        case 4:
          _context5.next = 6;
          return (0, _effects.call)(getFacebookToken, FB);

        case 6:
          facebookToken = _context5.sent;
          _context5.next = 9;
          return (0, _effects.call)(getFacebookProfile, FB);

        case 9:
          return _context5.abrupt('return', facebookToken);

        case 12:
          _context5.prev = 12;
          _context5.t0 = _context5['catch'](1);
          message = void 0;

          if (!(_context5.t0.message === FB_NOT_AVAILABLE)) {
            _context5.next = 19;
            break;
          }

          message = 'Facebook login not available at this time.';
          _context5.next = 26;
          break;

        case 19:
          if (!(_context5.t0.message === GET_FACEBOOK_TOKEN_FAILED)) {
            _context5.next = 23;
            break;
          }

          message = 'Facebook login failed.';
          _context5.next = 26;
          break;

        case 23:
          _context5.next = 25;
          return (0, _effects.call)(logger.error, 'Facebook login error message', _context5.t0.message);

        case 25:
          message = 'Sorry, something went wrong communicating with Facebook.';

        case 26:
          throw new Error(message);

        case 27:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this, [[1, 12]]);
}

function doLoginWithAuthToken(client, form, authToken) {
  var result;
  return _regenerator2.default.wrap(function doLoginWithAuthToken$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.call)(_statsd.increment, 'authentication.passwordless.attempted');

        case 3:
          _context6.next = 5;
          return (0, _effects.call)(requestLoginWithAuthToken, client, authToken);

        case 5:
          result = _context6.sent;
          _context6.next = 8;
          return (0, _effects.call)(_statsd.increment, 'authentication.passwordless.succeeded');

        case 8:
          return _context6.abrupt('return', result.token);

        case 11:
          _context6.prev = 11;
          _context6.t0 = _context6['catch'](0);
          _context6.next = 15;
          return (0, _effects.call)(_statsd.increment, 'authentication.passwordless.failed');

        case 15:
          if (!form) {
            _context6.next = 20;
            break;
          }

          if (!(_context6.t0.code === _apiErrorCodes.ERROR_PASSWORD_RESET_REQUIRED)) {
            _context6.next = 20;
            break;
          }

          _context6.next = 19;
          return (0, _effects.put)(form.failure(new _reduxForm.SubmissionError({
            _error: messages.authSecurityError
          })));

        case 19:
          return _context6.abrupt('return');

        case 20:
          throw _context6.t0;

        case 21:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this, [[0, 11]]);
}

function doLoginWithFacebook(client, form, facebookToken) {
  var result, message;
  return _regenerator2.default.wrap(function doLoginWithFacebook$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(_statsd.increment, 'authentication.facebook.attempted');

        case 3:
          if (facebookToken) {
            _context7.next = 7;
            break;
          }

          _context7.next = 6;
          return (0, _effects.call)(authorizeFacebook);

        case 6:
          facebookToken = _context7.sent;

        case 7:
          _context7.next = 9;
          return (0, _effects.call)(requestLoginWithFacebookToken, client, facebookToken);

        case 9:
          result = _context7.sent;
          _context7.next = 12;
          return (0, _effects.call)(doHandlePostAuth, client, result.token);

        case 12:
          _context7.next = 14;
          return (0, _effects.call)(_statsd.increment, 'authentication.facebook.succeeded');

        case 14:
          return _context7.abrupt('return', result.token);

        case 17:
          _context7.prev = 17;
          _context7.t0 = _context7['catch'](0);
          _context7.next = 21;
          return (0, _effects.call)(_statsd.increment, 'authentication.facebook.failed');

        case 21:
          message = _context7.t0.message;

          if (_context7.t0.code === _apiErrorCodes.ERROR_INVALID_CREDENTIALS) {
            message = messages.authError;
          }

          if (!form) {
            _context7.next = 28;
            break;
          }

          _context7.next = 26;
          return (0, _effects.put)(form.failure(new _reduxForm.SubmissionError({ _error: message })));

        case 26:
          _context7.next = 29;
          break;

        case 28:
          throw new Error(message);

        case 29:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this, [[0, 17]]);
}

function doLoginWithCredentials(client, form, email, password) {
  var result;
  return _regenerator2.default.wrap(function doLoginWithCredentials$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.call)(_statsd.increment, 'authentication.email.attempted');

        case 3:
          _context8.next = 5;
          return (0, _effects.call)(requestLoginWithCredentials, client, email, password);

        case 5:
          result = _context8.sent;
          _context8.next = 8;
          return (0, _effects.call)(doHandlePostAuth, client, result.token);

        case 8:
          _context8.next = 10;
          return (0, _effects.call)(_statsd.increment, 'authentication.email.succeeded');

        case 10:
          return _context8.abrupt('return', result.token);

        case 13:
          _context8.prev = 13;
          _context8.t0 = _context8['catch'](0);
          _context8.next = 17;
          return (0, _effects.call)(_statsd.increment, 'authentication.email.failed');

        case 17:
          if (!(_context8.t0.code === _apiErrorCodes.ERROR_INVALID_CREDENTIALS)) {
            _context8.next = 23;
            break;
          }

          _context8.next = 20;
          return (0, _effects.put)(form.failure(new _reduxForm.SubmissionError({
            _error: messages.authError
          })));

        case 20:
          return _context8.abrupt('return');

        case 23:
          if (!(_context8.t0.code === _apiErrorCodes.ERROR_PASSWORD_RESET_REQUIRED)) {
            _context8.next = 27;
            break;
          }

          _context8.next = 26;
          return (0, _effects.put)(form.failure(new _reduxForm.SubmissionError({
            _error: messages.authSecurityError
          })));

        case 26:
          return _context8.abrupt('return');

        case 27:
          throw _context8.t0;

        case 28:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this, [[0, 13]]);
}

function createUserAndLogIn(client, form, payload) {
  var result, authToken;
  return _regenerator2.default.wrap(function createUserAndLogIn$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.call)(client.users.create, payload);

        case 2:
          result = _context9.sent;

          if (!result.auth_token) {
            _context9.next = 9;
            break;
          }

          _context9.next = 6;
          return (0, _effects.call)(doLoginWithAuthToken, client, form, result.auth_token);

        case 6:
          _context9.t0 = _context9.sent;
          _context9.next = 24;
          break;

        case 9:
          if (!payload.facebook) {
            _context9.next = 15;
            break;
          }

          _context9.next = 12;
          return (0, _effects.call)(doLoginWithFacebook, client, form, payload.facebook.token);

        case 12:
          _context9.t1 = _context9.sent;
          _context9.next = 23;
          break;

        case 15:
          if (!payload.user) {
            _context9.next = 21;
            break;
          }

          _context9.next = 18;
          return (0, _effects.call)(doLoginWithCredentials, client, form, payload.user.email, payload.user.password);

        case 18:
          _context9.t2 = _context9.sent;
          _context9.next = 22;
          break;

        case 21:
          _context9.t2 = null;

        case 22:
          _context9.t1 = _context9.t2;

        case 23:
          _context9.t0 = _context9.t1;

        case 24:
          authToken = _context9.t0;

          if (!authToken) {
            _context9.next = 28;
            break;
          }

          _context9.next = 28;
          return (0, _effects.call)(doHandlePostAuth, client, authToken, true);

        case 28:
          return _context9.abrupt('return', result.id);

        case 29:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}